// Background presets for child cards in parent home view
// Each preset has a gradient and optional SVG pattern

export const BACKGROUND_PRESETS = {
  // OCEAN & SKY
  ocean: {
    name: 'Ocean',
    gradient: 'linear-gradient(to bottom right, #3b82f6, #2563eb, #06b6d4)',
    pattern: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.1'%3E%3Cpath d='M0 70 Q25 60 50 70 T100 70 V100 H0 Z'/%3E%3Cpath d='M0 80 Q25 73 50 80 T100 80 V100 H0 Z'/%3E%3C/g%3E%3C/svg%3E")`,
  },
  aurora: {
    name: 'Zorza',
    gradient: 'linear-gradient(135deg, #1e3a5f, #2d5a87, #3b82a0, #4ade80, #22d3ee)',
    pattern: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.08'%3E%3Cpath d='M0 40 Q20 30 40 45 T80 35 T100 40 V100 H0 Z'/%3E%3C/g%3E%3C/svg%3E")`,
  },
  skyline: {
    name: 'Niebo',
    gradient: 'linear-gradient(to bottom, #0ea5e9, #38bdf8, #7dd3fc, #bae6fd)',
    pattern: `url("data:image/svg+xml,%3Csvg width='120' height='60' viewBox='0 0 120 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.2'%3E%3Cellipse cx='30' cy='35' rx='18' ry='10'/%3E%3Cellipse cx='50' cy='30' rx='12' ry='8'/%3E%3Cellipse cx='70' cy='33' rx='15' ry='9'/%3E%3C/g%3E%3C/svg%3E")`,
  },

  // WARM TONES
  sunset: {
    name: 'Zachod slonca',
    gradient: 'linear-gradient(to bottom right, #f97316, #ef4444, #db2777)',
    pattern: `url("data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.15'%3E%3Ccircle cx='60' cy='100' r='40'/%3E%3Cpath d='M20 100 L40 80 L35 100 Z M80 80 L100 100 L85 100 Z'/%3E%3C/g%3E%3C/svg%3E")`,
  },
  fire: {
    name: 'Ogien',
    gradient: 'linear-gradient(to bottom right, #dc2626, #f97316, #eab308)',
    pattern: `url("data:image/svg+xml,%3Csvg width='80' height='100' viewBox='0 0 80 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.15'%3E%3Cpath d='M40 20 Q30 40 35 60 Q40 50 45 60 Q50 40 40 20 Z'/%3E%3Cpath d='M40 30 Q35 45 38 58 Q40 52 42 58 Q45 45 40 30 Z'/%3E%3C/g%3E%3C/svg%3E")`,
  },
  sunshine: {
    name: 'Sloneczny',
    gradient: 'linear-gradient(to bottom right, #facc15, #f59e0b, #ea580c)',
    pattern: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.2'%3E%3Ccircle cx='50' cy='50' r='15'/%3E%3Cpath d='M50 20 L50 10 M50 90 L50 80 M20 50 L10 50 M90 50 L80 50 M30 30 L23 23 M77 77 L70 70 M70 30 L77 23 M23 77 L30 70'/%3E%3C/g%3E%3C/svg%3E")`,
  },
  coral: {
    name: 'Koralowy',
    gradient: 'linear-gradient(to bottom right, #f43f5e, #fb923c, #f59e0b)',
    pattern: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.15'%3E%3Cpath d='M40 60 Q30 40 40 20 Q50 40 40 60 M30 55 Q35 45 40 55 M50 55 Q45 45 40 55'/%3E%3Ccircle cx='25' cy='35' r='4'/%3E%3Ccircle cx='55' cy='35' r='4'/%3E%3C/g%3E%3C/svg%3E")`,
  },
  peach: {
    name: 'Brzoskwiniowy',
    gradient: 'linear-gradient(135deg, #fcd34d, #fb923c, #f472b6)',
    pattern: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.15'%3E%3Ccircle cx='30' cy='30' r='12'/%3E%3Cpath d='M30 18 Q35 10 40 15'/%3E%3C/g%3E%3C/svg%3E")`,
  },

  // NATURE
  forest: {
    name: 'Las',
    gradient: 'linear-gradient(to bottom right, #16a34a, #059669, #0d9488)',
    pattern: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.12'%3E%3Cpath d='M20 60 L30 30 L40 60 Z M50 60 L60 25 L70 60 Z'/%3E%3Crect x='27' y='60' width='6' height='15'/%3E%3Crect x='57' y='60' width='6' height='15'/%3E%3C/g%3E%3C/svg%3E")`,
  },
  tropical: {
    name: 'Tropikalny',
    gradient: 'linear-gradient(to bottom right, #06b6d4, #14b8a6, #16a34a)',
    pattern: `url("data:image/svg+xml,%3Csvg width='90' height='90' viewBox='0 0 90 90' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.15'%3E%3Cpath d='M45 20 Q40 35 45 50 M45 50 Q50 35 45 20 M45 20 L40 15 M45 20 L50 15'/%3E%3Ccircle cx='25' cy='60' r='8'/%3E%3Ccircle cx='65' cy='60' r='8'/%3E%3C/g%3E%3C/svg%3E")`,
  },
  mint: {
    name: 'Mietowy',
    gradient: 'linear-gradient(135deg, #a7f3d0, #6ee7b7, #34d399, #10b981)',
    pattern: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.2'%3E%3Cpath d='M30 10 Q20 25 30 40 Q40 25 30 10'/%3E%3Cpath d='M30 40 L30 55'/%3E%3C/g%3E%3C/svg%3E")`,
  },

  // PURPLE & PINK
  royal: {
    name: 'Krolewski',
    gradient: 'linear-gradient(to bottom right, #9333ea, #7c3aed, #4338ca)',
    pattern: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.15'%3E%3Cpath d='M30 10 L35 25 L50 25 L38 35 L42 50 L30 40 L18 50 L22 35 L10 25 L25 25 Z'/%3E%3C/g%3E%3C/svg%3E")`,
  },
  lavender: {
    name: 'Lawendowy',
    gradient: 'linear-gradient(to bottom right, #c084fc, #8b5cf6, #9333ea)',
    pattern: `url("data:image/svg+xml,%3Csvg width='70' height='90' viewBox='0 0 70 90' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.15'%3E%3Crect x='30' y='10' width='4' height='30' rx='2'/%3E%3Cellipse cx='25' cy='12' rx='3' ry='5'/%3E%3Cellipse cx='32' cy='8' rx='3' ry='6'/%3E%3Cellipse cx='39' cy='12' rx='3' ry='5'/%3E%3C/g%3E%3C/svg%3E")`,
  },
  berry: {
    name: 'Jagodowy',
    gradient: 'linear-gradient(to bottom right, #db2777, #e11d48, #a21caf)',
    pattern: `url("data:image/svg+xml,%3Csvg width='50' height='50' viewBox='0 0 50 50' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.2'%3E%3Ccircle cx='15' cy='15' r='8'/%3E%3Ccircle cx='35' cy='20' r='6'/%3E%3Ccircle cx='25' cy='35' r='7'/%3E%3C/g%3E%3C/svg%3E")`,
  },
  candy: {
    name: 'Cukierki',
    gradient: 'linear-gradient(to bottom right, #ec4899, #a855f7, #3b82f6)',
    pattern: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.2'%3E%3Ccircle cx='20' cy='20' r='10'/%3E%3Ccircle cx='40' cy='40' r='10'/%3E%3Cpath d='M15 35 Q30 30 45 25' stroke='%23FFFFFF' stroke-opacity='0.2' stroke-width='3' fill='none'/%3E%3C/g%3E%3C/svg%3E")`,
  },
  bubblegum: {
    name: 'Guma balonowa',
    gradient: 'linear-gradient(135deg, #f9a8d4, #f472b6, #ec4899, #db2777)',
    pattern: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.15'%3E%3Ccircle cx='25' cy='25' r='15'/%3E%3Ccircle cx='55' cy='50' r='12'/%3E%3Ccircle cx='35' cy='60' r='8'/%3E%3C/g%3E%3C/svg%3E")`,
  },

  // DARK & ELEGANT
  midnight: {
    name: 'Polnoc',
    gradient: 'linear-gradient(to bottom right, #334155, #1e3a8a, #312e81)',
    pattern: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.2'%3E%3Ccircle cx='80' cy='20' r='3'/%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3Ccircle cx='60' cy='50' r='2'/%3E%3Ccircle cx='20' cy='70' r='3'/%3E%3Ccircle cx='70' cy='75' r='2'/%3E%3Cpath d='M40 15 L42 20 L47 20 L43 24 L45 29 L40 25 L35 29 L37 24 L33 20 L38 20 Z'/%3E%3C/g%3E%3C/svg%3E")`,
  },
  galaxy: {
    name: 'Galaktyka',
    gradient: 'linear-gradient(135deg, #0f172a, #1e1b4b, #4c1d95, #7c3aed)',
    pattern: `url("data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.15'%3E%3Ccircle cx='20' cy='20' r='2'/%3E%3Ccircle cx='80' cy='15' r='3'/%3E%3Ccircle cx='100' cy='40' r='2'/%3E%3Ccircle cx='40' cy='60' r='2'/%3E%3Ccircle cx='90' cy='80' r='3'/%3E%3Ccircle cx='30' cy='90' r='2'/%3E%3Ccircle cx='60' cy='35' r='4'/%3E%3Ccircle cx='70' cy='100' r='2'/%3E%3C/g%3E%3C/svg%3E")`,
  },
  nebula: {
    name: 'Mgławica',
    gradient: 'linear-gradient(135deg, #581c87, #7e22ce, #a855f7, #c084fc, #6366f1)',
    pattern: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.1'%3E%3Ccircle cx='50' cy='50' r='30'/%3E%3Ccircle cx='30' cy='30' r='15'/%3E%3Ccircle cx='70' cy='70' r='20'/%3E%3C/g%3E%3C/svg%3E")`,
  },

  // UNIQUE MULTI-COLOR
  rainbow: {
    name: 'Tecza',
    gradient: 'linear-gradient(135deg, #ef4444, #f97316, #eab308, #22c55e, #3b82f6, #8b5cf6)',
    pattern: `url("data:image/svg+xml,%3Csvg width='120' height='60' viewBox='0 0 120 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' stroke='%23FFFFFF' stroke-width='2' stroke-opacity='0.15'%3E%3Cpath d='M10 55 Q60 -5 110 55'/%3E%3Cpath d='M20 55 Q60 5 100 55'/%3E%3Cpath d='M30 55 Q60 15 90 55'/%3E%3C/g%3E%3C/svg%3E")`,
  },
  unicorn: {
    name: 'Jednorozec',
    gradient: 'linear-gradient(135deg, #fdf2f8, #fbcfe8, #f9a8d4, #c4b5fd, #a5b4fc, #93c5fd)',
    pattern: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.4'%3E%3Cpath d='M40 10 L42 25 L47 20 L43 30 L40 45'/%3E%3Ccircle cx='20' cy='50' r='3'/%3E%3Ccircle cx='60' cy='45' r='4'/%3E%3Ccircle cx='35' cy='65' r='3'/%3E%3C/g%3E%3C/svg%3E")`,
  },
  cotton: {
    name: 'Wata cukrowa',
    gradient: 'linear-gradient(135deg, #fce7f3, #ddd6fe, #bfdbfe, #a5f3fc)',
    pattern: `url("data:image/svg+xml,%3Csvg width='100' height='80' viewBox='0 0 100 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FFFFFF' fill-opacity='0.5'%3E%3Cellipse cx='25' cy='40' rx='18' ry='12'/%3E%3Cellipse cx='50' cy='35' rx='15' ry='10'/%3E%3Cellipse cx='75' cy='42' rx='16' ry='11'/%3E%3C/g%3E%3C/svg%3E")`,
  },
  confetti: {
    name: 'Konfetti',
    gradient: 'linear-gradient(135deg, #fef3c7, #fde68a, #fcd34d, #fb923c)',
    pattern: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill-opacity='0.25'%3E%3Crect fill='%23EF4444' x='10' y='15' width='6' height='3' transform='rotate(25 13 16)'/%3E%3Crect fill='%2322C55E' x='50' y='10' width='8' height='3' transform='rotate(-15 54 11)'/%3E%3Crect fill='%233B82F6' x='30' y='45' width='5' height='3' transform='rotate(40 32 46)'/%3E%3Crect fill='%238B5CF6' x='65' y='50' width='7' height='3' transform='rotate(-30 68 51)'/%3E%3Crect fill='%23EC4899' x='20' y='65' width='6' height='3' transform='rotate(15 23 66)'/%3E%3Crect fill='%2306B6D4' x='55' y='70' width='5' height='3' transform='rotate(-45 57 71)'/%3E%3C/g%3E%3C/svg%3E")`,
  },
};

// Get ordered list for UI selection
export const BACKGROUND_PRESET_LIST = Object.entries(BACKGROUND_PRESETS).map(([key, value]) => ({
  key,
  ...value,
}));

// Default background if none selected
export const DEFAULT_BACKGROUND = 'ocean';

// Get background style for a preset
export function getBackgroundStyle(presetKey) {
  const preset = BACKGROUND_PRESETS[presetKey] || BACKGROUND_PRESETS[DEFAULT_BACKGROUND];

  // All gradients are now inline CSS
  return {
    backgroundImage: `${preset.gradient}, ${preset.pattern}`,
    backgroundRepeat: 'repeat',
  };
}

// Get gradient classes for a preset (only for Tailwind-based gradients)
export function getGradientClasses(presetKey) {
  // All gradients are now inline CSS, so return empty string
  return '';
}
